import { useState, useRef, useEffect } from "react";

export function useIdleTimer(timeout = 1800000) {
    const [isIdle, setIsIdle] = useState(false);
    const timerRef = useRef(null);

    const resetTimer = () => {
        setIsIdle(false);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setIsIdle(true);
        }, timeout);
    };

    useEffect(() => {
        const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
        events.forEach((event) => window.addEventListener(event, resetTimer));
        resetTimer();

        return () => {
            events.forEach((event) => window.removeEventListener(event, resetTimer));
            clearTimeout(timerRef.current);
        };
    }, [timeout]);

    return isIdle;
}